import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroTestimonials() {
  const testimonials = [{
    initials: 'JM',
    quote: 'My son went from 3 minutes of focus to completing full 20-minute sessions on his own — in just 14 days.',
    author: 'Jessica M., Texas | Mom of a 7-year-old'
  }, {
    initials: 'AK',
    quote: 'She used to cry and quit the moment something felt hard. After 2 weeks she pushes through every single challenge.',
    author: 'Amanda K., Florida | Mom of an 8-year-old'
  }, {
    initials: 'RT',
    quote: 'By day three my kids were reminding ME to print the activity. In 6 years of parenting I never saw that.',
    author: 'Rachel T., California | Mom of two ages 6 and 9'
  }];
  return <section className="bg-cream py-12 px-4 border-b border-border" data-id="element-116">
      <div className="max-w-6xl mx-auto" data-id="element-117">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-118">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-lightgray rounded-xl p-6 border border-border shadow-sm flex flex-col" data-id="element-119">
              <div className="flex items-center mb-4" data-id="element-120">
                <div className="w-10 h-10 rounded-full bg-navy text-white flex items-center justify-center font-bold text-sm mr-3" data-id="element-121">
                  {t.initials}
                </div>
                <div className="flex" data-id="element-122">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-123" />)}
                </div>
              </div>
              <p className="text-ink italic mb-4 text-sm md:text-base flex-grow" data-id="element-124">
                "{t.quote}"
              </p>
              <p className="font-heading font-bold text-white text-xs md:text-sm" data-id="element-125">
                — {t.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}